import './ClearFilterButton.scss';
import React, { FC, useCallback } from 'react';
import Button from '@atoms/Button';
import DataGrid from 'devextreme-react/data-grid';
import TreeList from 'devextreme-react/tree-list';
import { MdFilterAltOff } from 'react-icons/md';

export interface IClearFiltersButtonProps {
    gridRef: React.RefObject<DataGrid<any, any> | null> | React.RefObject<TreeList<any, any> | null>;
}

const ClearFilterButton: FC<IClearFiltersButtonProps> = ({ gridRef }: IClearFiltersButtonProps) => {
    const onClick = useCallback(() => {
        gridRef.current?.instance.clearFilter();
    }, [gridRef]);

    return (
        <div className="clear-filter">
            <Button
                className="clear-filter__button"
                buttonType="round"
                textColor="neutral"
                size="s"
                startAdornment={<MdFilterAltOff size="24" />}
                onClick={onClick}
            >
                Очистить фильтры
            </Button>
        </div>
    );
};

export default ClearFilterButton;
